export default function InfoTable({ locationIDs, latLon, publicNote }) {
  let latLonString = 'N/A';
  let assetName = 'N/A';
  let notes = 'N/A';
  let notesClassName = 'infoTableValue';

  if (locationIDs && latLon) {
    latLonString = `${latLon[0]}, ${latLon[1]}`;
    notes = publicNote ? publicNote.trim() : ''; // trim unless truthiness resolves to false
    assetName = locationIDs.asset;
    notesClassName += ' bolded';
  }

  return (
    <>
      <table className='infoTable'>
        <caption className='infoTableTopRow'>
          Selected Asset Information
        </caption>
        <tbody>
          <tr>
            <th className='infoTableField'>Asset Name</th>
            <td className='infoTableValue'>{assetName}</td>
          </tr>
          <tr>
            <th className='infoTableField'>Lat, Lon</th>
            <td className='infoTableValue'>{latLonString}</td>
          </tr>
          <tr>
            <th className='infoTableField'>Notes</th>
            <td className={notesClassName}>{notes}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
}
